import Image from 'next/image';

export default Image;
